// Actions for the Agency Fulfilment Call Bot store module (STSMPD-1323).
//
// This slice is a lightweight, client-side cache of the latest call state per allocation so the
// Agency Shifts row can show a status Tag pill. It is populated by the AgencyCallModal as it
// short-polls the call service; the durable, team-visible record remains the admin alert + note.

import { AGENCY_CALL_STATE_SET, AGENCY_CALL_STATE_CLEAR, AGENCY_CALL_TRACK } from './action-types'
import { CallAlertState, CallStatus } from './types'

export type SetCallStatePayload = {
  allocationId: number
  lastState: CallAlertState | null
  status: CallStatus
  callRequestId: string
}

export const setAgencyCallState = (payload: SetCallStatePayload) => ({
  type: AGENCY_CALL_STATE_SET as typeof AGENCY_CALL_STATE_SET,
  payload,
})
export type SetAgencyCallStateAction = ReturnType<typeof setAgencyCallState>

export const clearAgencyCallState = (allocationId: number) => ({
  type: AGENCY_CALL_STATE_CLEAR as typeof AGENCY_CALL_STATE_CLEAR,
  allocationId,
})
export type ClearAgencyCallStateAction = ReturnType<typeof clearAgencyCallState>

/**
 * Hand a just-placed call off to the background tracking saga (see sagas/agency-call). The saga
 * polls the call service to completion and keeps `byAllocation[allocationId]` current, so the
 * Agency Shifts row pill reaches the terminal "Outcome" even if the user closes the modal and
 * moves on. Not handled by the reducer — it only drives the saga.
 */
export type TrackAgencyCallPayload = {
  allocationId: number
  callRequestId: string
}
export const trackAgencyCall = (payload: TrackAgencyCallPayload) => ({
  type: AGENCY_CALL_TRACK as typeof AGENCY_CALL_TRACK,
  payload,
})
export type TrackAgencyCallAction = ReturnType<typeof trackAgencyCall>

export type AgencyCallAction = SetAgencyCallStateAction | ClearAgencyCallStateAction
